import { connect, MapStateToProps } from 'react-redux';
import { AppAuthorizationPageProps } from './AppAuthorizationPage';
import { AppState } from '../../../types/store';

type StateProps = Pick<
  AppAuthorizationPageProps,
  'appDeviation' | 'requestedScope' | 'locationSearch'
>;
type OwnProps = Omit<AppAuthorizationPageProps, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  appDeviation: state.oauth.appSettings?.deviation,
  requestedScope: state.oauth.appSettings?.requestedScope || '',
  locationSearch: state.location?.search || '',
});

export default connect(mapStateToProps);
